export const MOCHI_SYSTEM_DEFAULTS = {
  assistant_name: "Mochi",
  avatar: "companion",
  palette: "classic",
  avatar_size: "md",
  avatar_placement: "bottom-right",
  mochi_enabled: true,
} as const;

export const AVATAR_REGISTRY: Record<string, { id: string; labelKey: string; palettes: string[] }> = {
  mochi: { id: "mochi", labelKey: "mochi.avatar.mochi", palettes: ["classic", "ocean", "forest", "mono"] },
  companion: { id: "companion", labelKey: "mochi.avatar.companion", palettes: [] },
};

export function resolveAvatarId(id: string | undefined): string {
  return id && id in AVATAR_REGISTRY ? id : "companion";
}
